import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames/bind';
import { Link, useLocation } from 'react-router-dom';

// State
import { fetchPageIsNeeded, fetchCompositeDetailIsNeeded } from '../../state/modules/page/actions';

// Components
import Heading from '../../components/Heading';
import Container from '../../components/Container';
import PageContent from '../../components/PageContent';
import BackIcon from '../../icons/back2.svg';
import StyledHtml from '../../components/StyledHtml';

// Styles
import styles from './Page.styl';
import { BLOG_PAGE_PATH_PART } from '../../state/modules/page/constants';
import Error404 from '../Error404/Error404';

const cx = classNames.bind(styles);
export default function Page(props) {
  const intl = useIntl();
  const { pathname } = useLocation();

  const { alias, backTo = null, className = '' } = props;

  const dispatch = useDispatch();
  const { compositePages = [], name, declension, _supertag } = useSelector(
    state => state.city.userCity,
  );
  const { isLoaded, list } = useSelector(state => state.page);
  const { title = '', body = '', sections = [] } = list[alias] || {};

  const isCompositePage = compositePages.includes(alias);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isCompositePage) {
      dispatch(fetchCompositeDetailIsNeeded(alias));
    } else {
      dispatch(fetchPageIsNeeded(alias));
    }
  }, []);

  // сильный хардкод
  const getDescription = currentAlias => {
    let description = '';

    const lowerAlias = currentAlias.toLowerCase();

    switch (lowerAlias) {
      case 'allergens': {
        description = intl.formatMessage(
          { id: 'page.allergens.helmet.description' },
          { declension, name },
        );
        break;
      }
      case 'dostavka': {
        description = intl.formatMessage(
          { id: 'page.dostavka.helmet.description' },
          { declension, name },
        );
        break;
      }
      case 'o-nas': {
        description = intl.formatMessage(
          { id: 'page.o-nas.helmet.description' },
          { declension, name },
        );
        break;
      }
      case 'oplata-kartami': {
        description = intl.formatMessage(
          { id: 'page.oplata-kartami.helmet.description' },
          { declension, name },
        );
        break;
      }
      case 'personal-data-processing-policy': {
        description = intl.formatMessage(
          { id: 'page.personal-data-processing-policy.helmet.description' },
          { declension, name },
        );
        break;
      }
      case 'questions': {
        description = intl.formatMessage(
          { id: 'page.questions.helmet.description' },
          { declension, name },
        );
        break;
      }
      default: {
        break;
      }
    }

    return description;
  };

  // Сокрытие блоговых страниц с супертэгом
  if (alias.startsWith(BLOG_PAGE_PATH_PART) && pathname.split('/')[1] === _supertag) {
    return <Error404 />;
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={getDescription(alias)} />
      </Helmet>
      <Container className={cx('Page', className)} size={isCompositePage ? 'm' : 's'}>
        {!!backTo && (
          <Link className={cx('Page__back')} to={backTo?.path}>
            <BackIcon />
            {backTo.title ?? intl.formatMessage({ id: 'button.back' })}
          </Link>
        )}
        {isLoaded ? (
          <>
            <Heading level={1} className={cx('Page__title')}>
              {title}
            </Heading>
            {isCompositePage ? (
              <PageContent sections={sections} />
            ) : (
              <StyledHtml
                html={body}
                // className={cx('Page__content')}
              />
            )}
          </>
        ) : (
          <div className={cx('Page__spinner')} />
        )}
      </Container>
    </>
  );
}

Page.defaultProps = {
  backTo: null,
  className: '',
};

Page.propTypes = {
  alias: PropTypes.string.isRequired,
  backTo: PropTypes.shape({
    path: PropTypes.string.isRequired,
    title: PropTypes.string,
  }),
  className: PropTypes.string,
};
